import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import CloseBtn from "../CloseBtn";

const SleeveModal = ({
  show,
  onHide,
  isEdit = null,
  form,
  setForm,
  saveSleeve,
  varCoords,
  setVarCoords,
  varSizes,
  setVarSizes,
  errors,
  setErrors,
}) => {
  const handleCoordChange = (key, field, value) => {
    setVarCoords((prev) => ({
      ...prev,
      [key]: { ...prev[key], [field]: value },
    }));
  };
  const handleSizeChange = (key, field, value) => {
    setVarSizes((prev) => ({
      ...prev,
      [key]: { ...prev[key], [field]: value },
    }));
  };

  const ORIENTATIONS = ["Portrait", "Landscape"];
  const PRINT_TYPES = ["One Side", "Front back"];

  console.log("Form ::: ", form);

  return (
    <Modal
      show={show}
      onHide={onHide}
      onExited={() => setErrors({})}
      size={"lg"}
      centered
    >
      <CloseBtn onClick={onHide} color="#bf352b" />
      <Modal.Header>
        <Modal.Title>{isEdit ? "Edit Sleeve" : "Add Sleeve"}</Modal.Title>
      </Modal.Header>

      <Form noValidate onSubmit={saveSleeve}>
        <Modal.Body>
          <div className={`d-grid gap-3 ${isEdit ? "" : "columns-2"}`}>
            {/* Common fields: always show */}
            <Form.Group>
              <Form.Label>Sleeve Type*</Form.Label>
              <Form.Control
                value={form.sleeve_type}
                // onChange={(e) =>
                //   setForm({ ...form, sleeve_type: e.target.value })
                // }
                onChange={(e) => {
                  setForm({ ...form, sleeve_type: e.target.value });
                  if (errors.sleeve_type)
                    setErrors((pr) => ({ ...pr, sleeve_type: undefined }));
                }}
                isInvalid={!!errors.sleeve_type}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.sleeve_type}
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group>
              <Form.Label>Sleeve Name*</Form.Label>
              <Form.Control
                value={form.sleeve_name}
                // onChange={(e) =>
                //   setForm({ ...form, sleeve_name: e.target.value })
                // }
                onChange={(e) => {
                  setForm({ ...form, sleeve_name: e.target.value });
                  if (errors.sleeve_name)
                    setErrors((pr) => ({ ...pr, sleeve_name: undefined }));
                }}
                isInvalid={!!errors.sleeve_name}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.sleeve_name}
              </Form.Control.Feedback>
            </Form.Group>
            {/* Extra fields: show only when adding */}

            {/* Sleeve Width */}

            <Form.Group>
              <Form.Label>Sleeve Width*</Form.Label>
              <Form.Control
                type="number"
                value={form.sleeve_width}
                // onChange={(e) =>
                //   setForm({ ...form, sleeve_width: e.target.value })
                // }
                onChange={(e) => {
                  setForm({ ...form, sleeve_width: e.target.value });
                  if (errors.sleeve_width)
                    setErrors((pr) => ({ ...pr, sleeve_width: undefined }));
                }}
                isInvalid={!!errors.sleeve_width}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.sleeve_width}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Sleeve Height */}

            <Form.Group>
              <Form.Label>Sleeve Height*</Form.Label>
              <Form.Control
                type="number"
                min="0"
                step="any"
                inputMode="decimal"
                value={form.sleeve_height}
                // onChange={(e) =>
                //   setForm({ ...form, sleeve_height: e.target.value })
                // }
                onChange={(e) => {
                  setForm({ ...form, sleeve_height: e.target.value });
                  if (errors.sleeve_height)
                    setErrors((pr) => ({
                      ...pr,
                      sleeve_height: undefined,
                    }));
                }}
                isInvalid={!!errors.sleeve_height}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.sleeve_height}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Print Page Width */}

            <Form.Group>
              <Form.Label>Print Page Width*</Form.Label>
              <Form.Control
                type="number"
                min="0"
                step="any"
                inputMode="decimal"
                value={form.print_page_width}
                // onChange={(e) =>
                //   setForm({ ...form, print_page_width: e.target.value })
                // }
                onChange={(e) => {
                  setForm({ ...form, print_page_width: e.target.value });
                  if (errors.print_page_width)
                    setErrors((pr) => ({
                      ...pr,
                      print_page_width: undefined,
                    }));
                }}
                isInvalid={!!errors.print_page_width}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.print_page_width}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Print Page Height */}

            <Form.Group>
              <Form.Label>Print Page Height*</Form.Label>
              <Form.Control
                type="number"
                min="0"
                step="any"
                inputMode="decimal"
                value={form.print_page_height}
                // onChange={(e) =>
                //   setForm({
                //     ...form,
                //     print_page_height: e.target.value,
                //   })
                // }
                onChange={(e) => {
                  setForm({ ...form, print_page_height: e.target.value });
                  if (errors.print_page_height)
                    setErrors((pr) => ({
                      ...pr,
                      print_page_height: undefined,
                    }));
                }}
                isInvalid={!!errors.print_page_height}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.print_page_height}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Orientation */}

            <Form.Group>
              <Form.Label>Orientation*</Form.Label>
              <Form.Select
                value={form.orientation}
                // onChange={(e) =>
                //   setForm({ ...form, orientation: e.target.value })
                // }
                onChange={(e) => {
                  setForm({ ...form, orientation: e.target.value });
                  if (errors.orientation)
                    setErrors((pr) => ({ ...pr, orientation: undefined }));
                }}
                isInvalid={!!errors.orientation}
                required
                className="cursor-pointer"
              >
                <option value="">Select Orientation</option>
                {ORIENTATIONS.map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
                {/* <option value="Portrait">Portrait</option>
                    <option value="Landscape">Landscape</option> */}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.orientation}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Print Type */}

            <Form.Group>
              <Form.Label>Print Type*</Form.Label>
              <Form.Select
                value={form.print_type}
                // onChange={(e) =>
                //   setForm({ ...form, print_type: e.target.value })
                // }
                className="cursor-pointer"
                onChange={(e) => {
                  setForm({ ...form, print_type: e.target.value });
                  if (errors.print_type)
                    setErrors((pr) => ({ ...pr, print_type: undefined }));
                }}
                isInvalid={!!errors.print_type}
                required
              >
                <option value="">Select Print Type</option>
                {PRINT_TYPES.map((p) => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
                {/* <option value="One Side">One Side</option>
                    <option value="Front back">Front back</option> */}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.print_type}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Qty in Page */}

            <Form.Group>
              <Form.Label>Qty in Page</Form.Label>
              <Form.Control
                type="number"
                min="1"
                step="1"
                inputMode="numeric"
                value={form.qty_in_page}
                // onChange={(e) =>
                //   setForm({ ...form, qty_in_page: e.target.value })
                // }
                onChange={(e) => {
                  setForm({ ...form, qty_in_page: e.target.value });
                  if (errors.qty_in_page)
                    setErrors((pr) => ({ ...pr, qty_in_page: undefined }));
                }}
                isInvalid={!!errors.qty_in_page}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.qty_in_page}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Variable Coordinates */}
            <div className="span-2 mt-3">
              <h5 className="mb-3">Variable Coordinates</h5>

              <Table responsive size="sm" className="m-0 no-bordered">
                <thead>
                  <tr>
                    <th style={{ width: 220 }}>Name</th>
                    <th style={{ width: 120 }}>X</th>
                    <th style={{ width: 120 }}>Y</th>
                    <th style={{ width: 140 }}>Font Size</th>
                    <th style={{ width: 160 }}>Font Type</th>
                    <th style={{ width: 140 }}>Font Style</th>
                    <th style={{ width: 140 }}>Print Side</th>
                    <th style={{ width: 160 }}>Font Colour</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    {
                      key: "client_name",
                      label: "Client Name",
                      hasFont: true,
                      hasType: true,
                    },
                    {
                      key: "order_id",
                      label: "Order ID",
                      hasFont: true,
                      hasType: true,
                    },
                    {
                      key: "date",
                      label: "Date",
                      hasFont: true,
                      hasType: true,
                    },
                    {
                      key: "partner_box",
                      label: "Partner Box (Position)",
                      hasFont: false,
                      hasType: false,
                    },
                  ].map((row) => (
                    <tr key={row.key}>
                      <td>{row.label}</td>
                      <td>
                        <Form.Control
                          type="number"
                          value={varCoords[row.key]?.x ?? ""}
                          onChange={(e) =>
                            handleCoordChange(row.key, "x", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          value={varCoords[row.key]?.y ?? ""}
                          onChange={(e) =>
                            handleCoordChange(row.key, "y", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          value={
                            row.hasFont
                              ? varCoords[row.key]?.font_size ?? ""
                              : ""
                          }
                          onChange={(e) =>
                            handleCoordChange(
                              row.key,
                              "font_size",
                              e.target.value
                            )
                          }
                          disabled={!row.hasFont}
                        />
                      </td>
                      <td>
                        {row.hasType ? (
                          <Form.Select
                            value={varCoords[row.key]?.type ?? "text"}
                            onChange={(e) =>
                              handleCoordChange(row.key, "type", e.target.value)
                            }
                          >
                            <option value="text">Straight</option>
                            <option value="dropdown">Rotate</option>
                          </Form.Select>
                        ) : (
                          <Form.Control value="" disabled />
                        )}
                      </td>
                      <td>
                        {row.hasFont ? (
                          <Form.Control
                            type="text"
                            value={varCoords[row.key]?.font_style ?? ""}
                            onChange={(e) =>
                              handleCoordChange(
                                row.key,
                                "font_style",
                                e.target.value
                              )
                            }
                          />
                        ) : (
                          <Form.Control value="" disabled />
                        )}
                      </td>
                      <td>
                        {row.hasType ? (
                          <Form.Control
                            type="text"
                            value={varCoords[row.key]?.print_side ?? ""}
                            onChange={(e) =>
                              handleCoordChange(
                                row.key,
                                "print_side",
                                e.target.value
                              )
                            }
                          />
                        ) : (
                          <Form.Control value="" disabled />
                        )}
                      </td>
                      <td>
                        {row.hasFont ? (
                          <Form.Control
                            type="text"
                            value={varCoords[row.key]?.font_colour ?? ""}
                            onChange={(e) =>
                              handleCoordChange(
                                row.key,
                                "font_colour",
                                e.target.value
                              )
                            }
                          />
                        ) : (
                          <Form.Control value="" disabled />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            {/* Variable Sizes */}
            <div className="span-2 mt-3">
              <h5 className="mb-3">Variable Sizes</h5>

              <Table responsive size="sm" className="mb-0 no-bordered">
                <thead>
                  <tr>
                    <th style={{ width: 220 }}>Name</th>
                    <th style={{ width: 140 }}>Width</th>
                    <th style={{ width: 140 }}>Height</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { key: "logo_size", label: "Logo Size" },
                    { key: "partner_box", label: "Partner Box" },
                  ].map((row) => (
                    <tr key={row.key}>
                      <td>{row.label}</td>
                      <td>
                        <Form.Control
                          type="number"
                          value={varSizes[row.key]?.width ?? ""}
                          onChange={(e) =>
                            handleSizeChange(row.key, "width", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          value={varSizes[row.key]?.height ?? ""}
                          onChange={(e) =>
                            handleSizeChange(row.key, "height", e.target.value)
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="span-2 mt-3">
              <h5 className="mb-3">Partners Variable</h5>

              <Table responsive size="sm" className="m-0 no-bordered">
                <thead>
                  <tr>
                    <th style={{ width: 220 }}>Name</th>
                    <th style={{ width: 140 }}>Font Size</th>
                    <th style={{ width: 160 }}>Font Type</th>
                    <th style={{ width: 140 }}>Font Style</th>
                    <th style={{ width: 140 }}>Print Side</th>
                    <th style={{ width: 160 }}>Font Colour</th>
                    <th style={{ width: 140 }}>Label Font Size</th>
                    <th style={{ width: 160 }}>Label Font Style</th>
                    <th style={{ width: 160 }}>Label Font Colour</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { key: "email", label: "Email" },
                    { key: "mobile", label: "Mobile" },
                    { key: "website", label: "Website" },
                    { key: "firm_name", label: "Firm Name" },
                    { key: "partner_name", label: "Partner Name" },
                    {
                      key: "amfi_registered_line",
                      label: "Amfi Registered Line",
                    },
                  ].map((row) => (
                    <tr key={row.key}>
                      <td>{row.label}</td>
                      <td>
                        <Form.Control
                          type="number"
                          value={varCoords[row.key]?.font_size ?? ""}
                          onChange={(e) =>
                            handleCoordChange(
                              row.key,
                              "font_size",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={varCoords[row.key]?.font_type ?? ""}
                          onChange={(e) =>
                            handleCoordChange(
                              row.key,
                              "font_type",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={varCoords[row.key]?.font_style ?? ""}
                          onChange={(e) =>
                            handleCoordChange(
                              row.key,
                              "font_style",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={varCoords[row.key]?.print_side ?? ""}
                          onChange={(e) =>
                            handleCoordChange(
                              row.key,
                              "print_side",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={varCoords[row.key]?.font_colour ?? ""}
                          onChange={(e) =>
                            handleCoordChange(
                              row.key,
                              "font_colour",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          value={varCoords[row.key]?.label_font_size ?? ""}
                          onChange={(e) =>
                            handleCoordChange(
                              row.key,
                              "label_font_size",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={varCoords[row.key]?.label_font_style ?? ""}
                          onChange={(e) =>
                            handleCoordChange(
                              row.key,
                              "label_font_style",
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          value={varCoords[row.key]?.label_font_colour ?? ""}
                          onChange={(e) =>
                            handleCoordChange(
                              row.key,
                              "label_font_colour",
                              e.target.value
                            )
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            {isEdit ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default SleeveModal;
